<div class="full-height">
<cl-login
  class="full-login-height"
  [Id]="LoginId"
  [ShouldResolve]="ShouldResolve"
  [ApiUrl]="ApiUrl"
  [PathToRedirect]="PathToRedirect"
  [SesionName]="SessionName"
  [LogoPath]="LogoPath"
  [DotNetApiType]="DotNetApiType"
  [UseReCaptcha]="UseReCaptcha">
</cl-login>

</div>
